export default "__VITE_ASSET__Bt66DSxf__"